import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ContentImage' })
export class ContentImagePipe implements PipeTransform {
    transform(input: any[], key: string): any {
        const item = input?.find(x => x.contentImageKey.toLowerCase() == key.toLowerCase());
        if (item) {
            // JsonConvert converts the byte[] to base 64
            return 'data:image/jpg;base64,' + item.contentImageValue;
        }
        else {
            //console.log('ContentImage not found', key);
            return '';
        }
    }
}
